import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";
import {currencyTypeFields} from "../../system-settings/currency-type/currency-type.graphql";


export const catalogPayableItemFields = `
id
itemUniqueId
itemName
itemUnitPrice
itemBulkPrice
itemBulkSize
chargingCurrency {
  ${currencyTypeFields}
}
`

export const CREATE_CATALOG_PAYABLE_ITEMS = gql`
  mutation CreateCatalogyPayableItems($input: CatalogyItemInputObjects!) {
    createCatalogyPayableItems(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${catalogPayableItemFields}
      }
    }
  }
`


export const UPDATE_CATALOG_PAYABLE_ITEMS = gql`
  mutation UpdateCatalogyPayableItems($input: CatalogyItemInputObjects!) {
    updateCatalogyPayableItems(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${catalogPayableItemFields}
      }
    }
  }
`

export const DELETE_CATALOG_PAYABLE_ITEMS = gql`
  mutation DeleteCatalogyPayableItems($itemUniqueId: String!) {
    deleteCatalogyPayableItems(itemUniqueId: $itemUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`


export const GET_CATALOG_PAYABLE_ITEMS = gql`
  query GetInstitutionServiceCatalogItems($catalogyUniqueId: String) {
    getInstitutionServiceCatalogItems(catalogyUniqueId: $catalogyUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${catalogPayableItemFields}
      }
    }
  }
`

export const CITIZEN_GET_INSTITUTION_SERVICE_CATALOG_SCHEMES = gql`
  query CitizenGetInstitutionServiceCatalogSchemes($billingUniqueId: String) {
    citizenGetInstitutionServiceCatalogSchemes(billingUniqueId: $billingUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${catalogPayableItemFields}
      }
    }
  }
`

export const CITIZEN_GET_INSTITUTION_SERVICE_CATALOG_ITEMS = gql`
  query CitizenGetInstitutionServiceCatalogItems($catalogyUniqueId: String) {
    citizenGetInstitutionServiceCatalogItems(catalogyUniqueId: $catalogyUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${catalogPayableItemFields}
      }
    }
  }
`;
